import { Icon } from '@kinesis/bungle';
const PathwaysIcon = () => (
  <Icon type='custom' magnitude='medium'>
    <svg
      width='1024'
      height='1024'
      viewBox='0 0 1024 1024'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='1024' height='1024' rx='128' fill='#7DB0D1' />
      <path
        // eslint-disable-next-line max-len
        d='M318.875 785H432.125V614.375H542C656 614.375 732.125 540.875 732.125 429.5V428.75C732.125 317.375 656 243.875 542 243.875H318.875V785ZM514.25 333.5C579.125 333.5 617.375 367.625 617.375 429.125V429.875C617.375 491.375 579.125 525.875 514.25 525.875H432.125V333.5H514.25Z'
        fill='white'
        fillOpacity='0.85'
      />
    </svg>
  </Icon>
);

export { PathwaysIcon };
